import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import { reExportedColors } from '../../index'

const ArrowIconUnsorted = () => (
  <IconButton
    sx={{
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      '& svg': { position: 'absolute' },
      '& svg:first-of-type': {
        color: `${reExportedColors.MEDIUM_GREY} !important`,
        top: '-3px'
      },
      '& svg:last-of-type': {
        color: `${reExportedColors.MEDIUM_GREY} !important`,
        top: '3px'
      }
    }}
  >
    <ArrowDropUpIcon />
    <ArrowDropDownIcon />
  </IconButton>
)

export default ArrowIconUnsorted
